import { RevoltGlassButton } from '../../../components';
import './DangerZoneCard.css';

export function DangerZoneCard({
  app,
  isOwner,
  onDelete,
}) {
  if (!app || !isOwner) return null;

  return (
    <div className="account-card settings-card danger-zone-card">
      <div className="card-header">
        <h2 className="card-title">
          <i className="fa-solid fa-triangle-exclamation"></i> Danger Zone
        </h2>
      </div>
      <div className="card-body danger-zone-body">
        <div className="danger-zone-content">
          <div className="danger-zone-description">
            <h3 className="danger-zone-title">Delete App</h3>
            <p className="danger-zone-text">
              Once you delete this app, there is no going back. Please be certain.
            </p>
          </div>
          <div className="danger-zone-actions">
            <RevoltGlassButton
              variant="danger"
              size="sm"
              onClick={onDelete}
            >
              Delete App
            </RevoltGlassButton>
          </div>
        </div>
      </div>
    </div>
  );
}